<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="yard-local-top-buttons">
    <ul class="header-radios">
        <li>
            <p-radioButton name="radioButtonYardLocal" [tabindex]='tabLevel' value="Y" label="{{configData?.yardLocalLabel.yardAndLocal}}"
             (click)='updateYardLocalOption();' [(ngModel)]="yardLocalOption"></p-radioButton>
        </li>

        <li>
            <p-radioButton name="radioButtonYardLocal" [tabindex]='tabLevel + 1' value="M" label="{{configData?.yardLocalLabel.mow}}"
             (click)='updateYardLocalOption();' [(ngModel)]="yardLocalOption"></p-radioButton>
        </li>
        <li>
            <p-radioButton name="radioButtonYardLocal" [tabindex]='tabLevel + 2' value="S" label="{{configData?.yardLocalLabel.specialAllocations}}"
             (click)='updateYardLocalOption();'  [(ngModel)]="yardLocalOption"></p-radioButton>
        </li>
        <li>
            <p-radioButton name="radioButtonYardLocal" [tabindex]='tabLevel + 3' value="A" label="{{configData?.yardLocalLabel.all}}"
             (click)='updateYardLocalOption();'    [(ngModel)]="yardLocalOption"></p-radioButton>
        </li>
    </ul>

    <span class="special-allocations">
  <p-checkbox value="val1"  [tabindex]='tabLevel + 4' label="{{configData?.yardLocalLabel.includeSpecialAllocations}}" (click)='updateYardLocalOption();' [disabled]="(yardLocalOption === 'S')"
    [(ngModel)]="isIncludeSpecialAllocation" binary="true"></p-checkbox>
</span>
    <div class="buttons-grp">
        <button id="defaultSearchButton" class="p-button-secondary" tabindex="{{tabLevel + 5}}" type="button" (click)='searchYardLocal();'>
              <span class='fa fa-search'></span> Search</button>

        <button type="button" tabindex="{{tabLevel + 6}}" [disabled]="!isPlanButtonEnabled" [ngClass]="isPlanButtonEnabled ? 'p-button-secondary ml-3': 'p-button-secondary p-button-disabled ml-3'"
            (click)="popupEventType?.emit('planLocomotiveOpr')">
  <span class="fa fa-exchange"></span>
      {{configData?.yardLocalLabel.plan}}
   </button>

        <button type="button" tabindex="{{tabLevel + 7}}" [disabled]="!isAllocateButtonEnabled" [ngClass]="isAllocateButtonEnabled ? 'p-button-secondary ml-3': 'p-button-secondary p-button-disabled ml-3'"
            (click)="popupEventType?.emit('allocateOpr')">
    <span class="fa fa-allocate"></span>
       {{configData?.yardLocalLabel.allocate}}
  </button>

        <button type="button" tabindex="{{tabLevel + 8}}" [disabled]="!isDeAllocateButtonEnabled" [ngClass]="isDeAllocateButtonEnabled ? 'p-button-secondary ml-3': 'p-button-secondary p-button-disabled ml-3'"
            (click)="popupEventType?.emit('deallocateOpr')">
    <span class="fa fa-ban"></span>
     {{configData?.yardLocalLabel.deallocate}}
  </button>

        <p-splitButton styleClass="split-button-ui" [tabindex]="tabLevel + 9" label="Other Actions" [model]="otherOptions" [disabled]="user && !user.isUserManagerOrDirector">
        </p-splitButton>
    </div>

</div>